import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat } from 'ol/proj';
import TileState from 'ol/TileState';

const Oslo = fromLonLat([10.7522, 59.9139]);

export const view = new View({
	center: Oslo,
	zoom: 12,
	maxZoom: 19
});

export const map = new Map({
	target: 'map',
	layers: [
		new TileLayer({
			source: new XYZ({
				url: 'https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
				crossOrigin: 'anonymous'
			})
		})
	],
	view: view
});

const controls = document.querySelectorAll('.ol-control button');

Array.from(controls).forEach(control => {
	control.addEventListener('focus', function() {
		control.parentElement.classList.add('focused');
	});

	control.addEventListener('blur', function() {
		control.parentElement.classList.remove('focused');
	});
});
